import { TestWebPushFormValues } from 'modules/webPush/WebPushV2/context';
import * as actionTypes from './actionTypes';
import { CreateWebPushFormValues, DeleteWebPushFormValues, WebPushIntegration } from './types';

/*------------------------------------------------------------------------------------------------*/
/* WebPush Fetch Actions                                                                          */
/*------------------------------------------------------------------------------------------------*/

export const fetchWebPushRequest = () => ({
  type: actionTypes.FETCH_WEB_PUSH_REQUEST,
});

export const fetchWebPushError = (error: string) => ({
  type: actionTypes.FETCH_WEB_PUSH_ERROR,
  error,
});

export const fetchWebPushResponse = (response: WebPushIntegration[]) => ({
  type: actionTypes.FETCH_WEB_PUSH_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* WebPush Create Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const createWebPushRequest = (params: CreateWebPushFormValues) => ({
  type: actionTypes.CREATE_WEB_PUSH_REQUEST,
  params,
});

export const createWebPushError = (error: string) => ({
  type: actionTypes.CREATE_WEB_PUSH_ERROR,
  error,
});

export const createWebPushResponse = (response: CreateWebPushFormValues) => ({
  type: actionTypes.CREATE_WEB_PUSH_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* WebPush Delete Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const deleteWebPushRequest = (params: Partial<DeleteWebPushFormValues>) => ({
  type: actionTypes.DELETE_WEB_PUSH_REQUEST,
  params,
});

export const deleteWebPushError = (error: string) => ({
  type: actionTypes.DELETE_WEB_PUSH_ERROR,
  error,
});

export const deleteWebPushResponse = (response: DeleteWebPushFormValues) => ({
  type: actionTypes.DELETE_WEB_PUSH_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* WebPush Send Web Push Actions                                                                  */
/*------------------------------------------------------------------------------------------------*/

export const sendWebPushRequest = (
  params: TestWebPushFormValues & { pushConfig: WebPushIntegration },
) => ({
  type: actionTypes.SEND_WEB_PUSH_REQUEST,
  params,
});

export const sendWebPushError = (error: string) => ({
  type: actionTypes.SEND_WEB_PUSH_ERROR,
  error,
});

export const sendWebPushResponse = (response: TestWebPushFormValues) => ({
  type: actionTypes.SEND_WEB_PUSH_RESPONSE,
  response,
});
